"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EditorState_1 = __importDefault(require("../EditorState"));

var constants_1 = require("../constants");

function updateSelection(editorState, selection) {
  return new EditorState_1.default(Object.assign({
    lastChangeType: constants_1.COMMAND.CHANGE_SELECTION
  }, editorState, selection));
}

exports.default = updateSelection;